module.exports = __webpack_public_path__ + "static/media/photo.66825ac4.webp";